var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { H5 } from "@irati/ui/src/Headings";
import { Card } from "@irati/ui/src/Layout";
export var AdminStat = styled(H5)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  word-break: break-all;\n  text-align: end;\n"], ["\n  color: ", ";\n  word-break: break-all;\n  text-align: end;\n"])), function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.colors.perkbox.blue;
});
export var AtAGlanceCard = styled(Card)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 32%;\n  background-color: ", ";\n  padding: 16px;\n"], ["\n  width: 32%;\n  background-color: ", ";\n  padding: 16px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.utility.highlight;
});
export var FullWidth = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n  ", "\n"], ["\n  width: 100%;\n  ",
    "\n"])), function (_a) {
    var isHeading = _a.isHeading;
    return isHeading
        ? "\n      min-height: 20px;\n      margin-bottom: 4px;\n     "
        : "flex-grow: 1";
});
var templateObject_1, templateObject_2, templateObject_3;
